import script from "./SaleShippings.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleShippings.vue?vue&type=script&setup=true&lang=js"

import "./SaleShippings.vue?vue&type=style&index=0&id=ad8b140c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad8b140c"]])

export default __exports__